import React from 'react';
import { connect } from 'react-redux';
import { saveInviteHash } from 'registration/creative/ducks';
import RedeemInvite from 'registration/creative/components/redeem_invite';

export default connect(() => ({}), { saveInviteHash })(RedeemInvite);



// WEBPACK FOOTER //
// ./registration/creative/containers/redeem_invite.js